import {
  ADVERTISING,
  ANALYTICS,
  ESSENTIAL,
  PERFORMANCE,
  SOCIAL_NETWORKING,
  UNCLASSIFIED,
} from 'constants/categories'


export const GCM_TO_TERMLY = {
  ad_personalization: ADVERTISING,
  ad_storage: ADVERTISING,
  ad_user_data: ADVERTISING,
  analytics_storage: ANALYTICS,
  functionality_storage: PERFORMANCE,
  personalization_storage: PERFORMANCE,
  security_storage: ESSENTIAL,
  social_storage: SOCIAL_NETWORKING,
  // Not really a thing, but this is what I do in the GTM template, so
  // I'm going to use it here to be consistent.
  unclassified_storage: UNCLASSIFIED,
}
